/*** IMPORTS FROM imports-loader ***/
var define = false;

import { showElement, hideElement } from '../util/showHideElements';
import { addFilterClass, removeFilterClass } from '../util/profileCardFilters';
import profileCardMasonry from '../util/profileCardMasonry';

const filterEls = document.querySelectorAll('[data-discipline-filter-id]');
const cardEls = document.querySelectorAll('[data-discipline-id]');
const titleEls = document.querySelectorAll('[data-display-discipline-title]');
const profileCardsLists = document.querySelectorAll('[data-profile-cards-list]');
const hiddenClassName = 'hidden-by-discipline';
const filteredClassName = 'filtered-by-discipline';
let alphaSorted = false;
let activeFilterId = '';

function clearFilter() {
  const params = new URLSearchParams(location.search);
  params.delete('discipline');
  const paramString = Array.from(params).length ? `?${params.toString()}` : '';
  window.history.replaceState({}, '', `${location.pathname}${paramString}`);

  cardEls.forEach((cardEl) => showElement(cardEl, hiddenClassName));
}

function clearTitle() {
  titleEls.forEach((titleEl) => {
    const titleId = titleEl.dataset.displayDisciplineTitle;
    const showHideEls = document.querySelectorAll(
      `[data-discipline-title-showhide="${titleId}"]`,
    );
    const originalText = typeof titleEl.dataset.originalText !== 'undefined' ? titleEl.dataset.originalText : titleEl.textContent;
    titleEl.textContent = originalText;
    titleEl.removeAttribute('data-original-text');
    titleEl.dispatchEvent(new CustomEvent('updatedSize')); // for match width elements

    showHideEls.forEach((containerEl) => hideElement(containerEl));
  });
}

function setFilter(disciplineFilterId, disciplineTitle) {
  const params = new URLSearchParams(location.search);
  activeFilterId = disciplineFilterId;
  params.set('discipline', disciplineTitle);
  window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
  cardEls.forEach((cardEl) => {
    // If the discipline ID is the same or the , show the card, if not, hide it.
    if (
      // checks for matching discipline ID
      parseInt(cardEl.dataset.disciplineId) === disciplineFilterId
      // If filter is for board of governors, check for boolean
      || disciplineFilterId === -1 && cardEl.dataset.boardWinner
    ) {
      showElement(cardEl, hiddenClassName);
    } else {
      hideElement(cardEl, hiddenClassName);
    }
  });
}

function setTitle(title) {
  titleEls.forEach((titleEl) => {
    const titleId = titleEl.dataset.displayDisciplineTitle;
    const showHideEls = document.querySelectorAll(
      `[data-discipline-title-showhide="${titleId}"]`,
    );
    if (typeof titleEl.dataset.originalText === 'undefined') {
      titleEl.dataset.originalText = titleEl.textContent;
    }
    titleEl.textContent = title;
    titleEl.dispatchEvent(new CustomEvent('updatedSize')); // for match width elements
    showHideEls.forEach((containerEl) => showElement(containerEl));
  });
}

function alphaSort() {
  profileCardMasonry.destroy();
  let cardsArray = Array.prototype.slice.call(cardEls, 0);
  cardsArray.sort((a, b) => a.dataset.sortName.localeCompare(b.dataset.sortName));

  cardsArray.forEach(function (cardEl) {
    cardEl.parentNode.appendChild(cardEl);
  });

  const profileCardsList = document.querySelectorAll('[data-profile-cards-list]');
  profileCardsList.forEach((list) => {
    profileCardMasonry.add(list);
  });

  alphaSorted = true;
}

function setActiveFilter(filterEl) {
  clearActiveFilters();
  console.log(filterEl);
  filterEl.classList.add('active');
}

function clearActiveFilters() {
  filterEls.forEach((filterEl) => filterEl.classList.remove('active'));
}

export default function () {
  filterEls.forEach((filterEl) => {
    filterEl.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Sort all items alphabetically if not already sorted
      if (!alphaSorted) {
        alphaSort();
      }

      // hide and show items
      const disciplineFilterId = filterEl.dataset.disciplineFilterId;
      const disciplineTitle = filterEl.dataset.disciplineTitle;

      if (
        disciplineFilterId === ''
        // clear filter when clicking the already selected item
        || parseInt(disciplineFilterId) === activeFilterId
      ) {
        // Show all if discipline ID is blank
        clearFilter();
        // Clear discipline title
        clearTitle();
        // Remove filtered appearance
        profileCardsLists.forEach((profileCardsList) => removeFilterClass(profileCardsList, filteredClassName));
        // unbold all filters
        clearActiveFilters();
      } else {
        // Filter by discipline ID
        setFilter(parseInt(disciplineFilterId), disciplineTitle);
        // Set discipline title
        setTitle(disciplineTitle);
        // Add filtered appearance
        profileCardsLists.forEach((profileCardsList) => addFilterClass(profileCardsList, filteredClassName));
        // Bold current; unbold others
        setActiveFilter(e.target);
      }

      // Reload masonry after update
      profileCardMasonry.layout();
    });
  });

  // applies filter if in URL string
  const urlParams = new URLSearchParams(location.search);
  const selectedDisciplineTitle = urlParams.get('discipline');
  if (selectedDisciplineTitle) {
    const selectedDisciplineEl = document.querySelector(`.disciplines-list a[data-discipline-title="${selectedDisciplineTitle}"]`);
    if (selectedDisciplineEl) {
        alphaSort();
        setFilter(parseInt(selectedDisciplineEl.dataset.disciplineFilterId), selectedDisciplineTitle);
        setTitle(selectedDisciplineTitle);
        profileCardsLists.forEach((profileCardsList) => addFilterClass(profileCardsList, filteredClassName));
        setActiveFilter(selectedDisciplineEl);
        profileCardMasonry.layout();
    }
  }
}

